import { render, staticRenderFns } from "./PartnersRequest.vue?vue&type=template&id=66891e3a&scoped=true&"
import script from "./PartnersRequest.vue?vue&type=script&lang=js&"
export * from "./PartnersRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66891e3a",
  null
  
)

export default component.exports